import { render, staticRenderFns } from "./ProductsReports.vue?vue&type=template&id=7300efc6&scoped=true&"
import script from "./ProductsReports.vue?vue&type=script&lang=js&"
export * from "./ProductsReports.vue?vue&type=script&lang=js&"
import style0 from "./ProductsReports.vue?vue&type=style&index=0&id=7300efc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7300efc6",
  null
  
)

export default component.exports